import React, { useCallback } from 'react';
import { EXPORT_DATA_QUERY, ExportDataQuery_forecastingResults_data_export } from 'data/ForecastingResults';
import { ReactComponent as LoadingState } from 'svg/loader.svg';
import { useLazyQuery } from '@apollo/client';
import { useForecastingState } from './ForecastingContextProvider';

export default function ExportScreenList() {
    const { forecastingId, forecastingState } = useForecastingState();
    const [triggerScreenExport, { data, loading: exportInProgress }] = useLazyQuery(EXPORT_DATA_QUERY);

    const downloadExportFile = useCallback(() => {
        return triggerScreenExport({
            variables: {
                forecastingId
            },
            onCompleted: data => {
                const content = '' + formatExportContent(data.forecastingResults.data?.export);
                const fileBlob = new Blob([content], { type: 'text/csv' });
                const exportFileName = 'ScreenList-' + new Date().toISOString() + '.csv';
                const element = document.createElement('a');
                const url = URL.createObjectURL(fileBlob);
                element.setAttribute('href', url);
                element.setAttribute('download', exportFileName);
                element.style.visibility = 'hidden';
                // append and simulate link click
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            },
            onError: error => {
                console.error(`Error getting screen export: ${error}`);
            },
            fetchPolicy: 'network-only',
            nextFetchPolicy: 'no-cache'
        });
    }, [forecastingId]);

    if (forecastingState !== 'loaded') return null;
    return (
        <div style={{ right: '50px' }} className='leaflet-bottom'>
            <div className='bg-white rounded-md py-4 px-4 m-4 shadow-sm pointer-events-auto'>
                <div className='w-auto h-10 flex'>
                    <button className={`flex-auto bg-blue-500 text-white font-bold py-2 px-4 rounded
                                        ${exportInProgress ? 'cursor-not-allowed opacity-50' : 'hover:bg-blue-700'}
                                       `}
                            onClick={() => downloadExportFile()}
                            disabled={exportInProgress}
                    >Download screen list
                    </button>
                    {
                        exportInProgress &&
                        <LoadingState className='flex-auto CampaignSpendOverlayLoadingState h-10 w-10' />
                    }
                </div>
            </div>
        </div>
    );
}

function formatExportContent(
    records: ExportDataQuery_forecastingResults_data_export[] | undefined
) {
    return records?.map((record => record.row)).join('\n');
}
